/** Short time-of-day label for the experienced-dashboard header ("Evening, {name}"). */
export const getTimeBasedGreetingPeriod = (
  hour: number = new Date().getHours()
): "morning" | "afternoon" | "evening" | "night" => {
  if (hour >= 5 && hour < 12) return "morning";
  if (hour >= 12 && hour < 17) return "afternoon";
  if (hour >= 17 && hour < 21) return "evening";
  return "night";
};
